import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

import InputField from '../../common/components/inputField';
import Alert from '../../common/components/Alert';

import * as constants from '../../config/constants';
import classes from '../../css/getCSS';
import pdfPreviewImage from '../../assets/img/pdf_preview.jpg';


const idUploadForm = (props) => {
  let files = null;
  console.log('idUploadForm===props',props);
  console.log(props.user.site.url);
  let site_data = constants.INDIAN_SITES.find(site => site[0] === props.user.site.url)

  files = props.files.map((file) => {
    let url = null;
    if (file.file_type === 'IMAGE') {
      url = constants.BASE_URL + file.thumbnail;
    } else {
      url = pdfPreviewImage;
    }

    let removeButton = (
      <Button
        variant="outlined"
        size="small"
        onClick={() => props.deleteFile(file.id)}
        className={classes.roundIconButton}
      >
        <DeleteIcon style={{ fontSize: '16px' }} />
      </Button>
    );
    if (props.editMode && props.fileType === 'IMAGE' && props.files.length === 1) {
      removeButton = null;
    }
    return (
      <Grid item md={3} xs={6} sm={3} align="center" key={file.id}>
        <img
          src={url}
          alt={file.file_type}
          className={classes.formImage}
        />
        <br />
        {removeButton}
      </Grid>
    );
  });

  let uploadForm = null;
  if ((props.files.length < 1) || (props.files.length < 3 && props.fileType === 'IMAGE')) {
    uploadForm = (
      <Grid container spacing={8}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="file"
            config={props.inputs.file}
            changed={event => props.inputChangedHandler(event, 'file')}
          />
        </Grid>
      </Grid>
    );
  }

  let nonFieldErrors = null;
  if (props.errors) {
    nonFieldErrors = props.errors.map((error) => {
      return (
        <Alert key={error} type="danger">{error}</Alert>
      );
    });
  }

  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button} >
      Update
    </Button>
  );

  if (!props.editMode) {
    let nextButton = (
      <Button type="submit" variant="contained" color="primary" size="large" className={classes.Button}>
        Next
        <NextIcon />
      </Button>
    );
    if ((props.fileType === 'IMAGE') && props.files.length === 0) {
      nextButton = null;
    }
    buttons = (
      <React.Fragment>
        <br />
        <hr className={classes.formHR} />
        <br />
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        {nextButton}
      </React.Fragment>
    );
  }

  let idNo = (
    <Grid item md={6} xs={12} sm={6}>
      <InputField
        id="id_proof_no"
        config={props.inputs.id_proof_no}
        changed={event => props.inputChangedHandler(event, 'id_proof_no')}
      />
    </Grid>
  )
  // const userData=JSON.parse(localStorage.getItem('user'))
  // console.log('idUploadForm===userData',userData);
  // let site = constants.INDIAN_SITES.find(site=>site[0]===userData.site.url)
  // if (site){
  //   idNo = (
  //     <Grid item md={6} xs={12} sm={6}>
  //       <InputField
  //         id="aadhaar_no"
  //         config={props.inputs.id_proof_no}
  //         changed={event => props.inputChangedHandler(event, 'id_proof_no')}
  //       />
  //     </Grid>
  //   )
  // }else {
  //   idNo = (
  //     <Grid item md={6} xs={12} sm={6}>
  //       <InputField
  //         id="id_proof_no"
  //         config={props.inputs.id_proof_no}
  //         changed={event => props.inputChangedHandler(event, 'id_proof_no')}
  //       />
  //     </Grid>
  //   )
  // }

  return (
    <React.Fragment>
      <blockquote className={classes.profileFormQuote}>
          Only PDF & IMAGE files allowed. You can upload max 1 file. <b>Uploading file should not be more then 5 mb.</b>
      </blockquote>
      <br />
      {nonFieldErrors}
      <Grid container spacing={24}>
        {files}
      </Grid>
      <br /><br />
      {uploadForm}
      {idNo}
      <span style={{color:'red'}}>Note:</span>
      {
        site_data?
          ' Upload Govt-recognized Photo ID Proof(AadhaarCard)':
          ' Upload Govt-recognized Photo ID Proof(Citizenship/PR or Green Card, Driving License, Voter ID, etc)'
      }
      <br/><br/>
      {buttons}
    </React.Fragment>
  );
};

export default idUploadForm;



// WEBPACK FOOTER //
// ./src/profile/components/IdUploadForm.js